import { Outlet } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { Box, Button, Link, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useCatalogSessionsDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { formatSessionDate } from 'modules/trainings/lib/utils'

export default function CatalogDetailSessionsPage() {
  return (
    <Box>
      <CatalogSessionsDatatable />
      <Outlet />
    </Box>
  )
}

function CatalogSessionsDatatable() {
  const { trainingId } = useParams<{ trainingId: string }>()
  const { debouncedSearch, search, onSearch } = useDebouncedSearch()
  const { navigation } = useNavigation()
  const source = useCatalogSessionsDataTable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Path,
        title: i18n.t('trainings.my_trainings_revamp.sessions_datatable.name'),
        path: 'name',
      },
      {
        identifier: 'date',
        width: 300,
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.my_trainings_revamp.sessions_datatable.date'),
        render: ({ startsAt, endsAt, duration, dueDate, schedule }) =>
          formatSessionDate({ startsAt, endsAt, dueDate, duration, schedule }),
        template: '{{ date }}',
      },
      {
        identifier: 'location',
        kind: ProjectionKind.Path,
        title: i18n.t('trainings.my_trainings_revamp.sessions_datatable.location'),
        path: 'location',
      },
      {
        identifier: 'link',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.my_trainings_revamp.sessions_datatable.link'),
        render: ({ link }) =>
          link ? (
            <Link.Href href={link} external title="Link">
              <Text color="textLink" size="300">
                {'Link'}
              </Text>
            </Link.Href>
          ) : (
            '-'
          ),
        template: '{{link}}',
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        width: 80,
        render: ({ id }) => (
          <Box alignItems="flexEnd" flexDirection="row">
            <Button.Router
              type="secondary"
              to={navigation.trainings.catalog.detail.sessions.sidepanel.fullPath({
                trainingId: Number(trainingId),
                sessionId: id,
              })}
              iconName="arrow-right"
            />
          </Box>
        ),
      },
    ],
    {
      variables: {
        search: debouncedSearch,
        trainingId: Number(trainingId),
        startsAfter: new Date().toISOString(),
      },
    }
  )
  return (
    <DataTable
      source={source}
      disableDefaultActions
      search={{
        placeholder: i18n.t('common.search'),
        value: search,
        onChange: onSearch,
      }}
    />
  )
}
